const ENV_LIST = {
  dev: {
    //开发环境
    nanfangIfUrl: 'https://testapi.nfnews.com/nanfang_if', //接口
    nfplusUrl: 'https://devzmyapi.nfnews.com/nfplus-manuscript-web', // 热文榜接口
    staticUrl: 'https://devstatic.nfnews.com', //用于跳转南方号分享页
    shareUrl: 'https://devstatic.nfnews.com/apptpl/hotArticleShare/', //打榜分享页
    downloadUrl: 'https://devstatic.nfnews.com/hd/download/download.html', //引导页地址
    wxLoginUrl: 'https://devmember.nfnews.com', //微信授权
    wxAppId: 'wx6354e45fd05077bc',
    env: 'dev',
    wxShareLogo: 'https://teststatic.nfnews.com/common/assets/images/nf_logo_artShare.png',
    caijiUrl: 'https://devanalyticsapi.nfnews.com/analytics/sendRecord',
  },
  test: {
    //测试环境
    nanfangIfUrl: 'https://testapi.nfnews.com/nanfang_if', //接口
    nfplusUrl: 'https://testnfplusapi.nfnews.com/nfplus-manuscript-web', // 热文榜接口
    staticUrl: 'https://teststatic.nfnews.com', //用于跳转南方号分享页
    shareUrl: 'https://teststatic.nfnews.com/apptpl/hotArticleShare/', //打榜分享页
    downloadUrl: 'https://teststatic.nfnews.com/hd/download/download.html', //引导页地址
    wxLoginUrl: 'https://testmember.nfnews.com', //微信授权
    wxAppId: 'wx6354e45fd05077bc',
    env: 'test',
    wxShareLogo: 'https://teststatic.nfnews.com/common/assets/images/nf_logo_artShare.png',
    caijiUrl: 'https://testanalyticsapi.nfnews.com/analytics/sendRecord',
  },
  pro: {
    //生产环境（命令行参数（process.arg）中prod是保留字，所以使用pro）
    nanfangIfUrl: 'https://api.nfnews.com/nanfang_if', //接口
    nfplusUrl: 'https://nfplusapi.nfnews.com/nfplus-manuscript-web', // 热文榜接口
    staticUrl: 'https://static.nfnews.com', //用于跳转南方号分享页
    shareUrl: 'https://static.nfnews.com/apptpl/nfhRankList/', //打榜分享页
    downloadUrl: 'https://static.nfnews.com/hd/download/download.html', //引导页地址
    wxLoginUrl: 'https://member.nfnews.com', //微信授权
    wxAppId: 'wx847772b3a82d4e8f',
    env: '',
    wxShareLogo: 'https://static.nfnews.com/common/assets/images/nf_logo_artShare.png',
    caijiUrl: 'https://analyticsapi.nfnews.com/analytics/sendRecord',
  },
};

const HOST_ENV = process.env.HOST_ENV;
const HOST_CONF = ENV_LIST[HOST_ENV];
const { nanfangIfUrl, nfplusUrl, staticUrl, shareUrl, downloadUrl, wxLoginUrl, wxAppId, env, wxShareLogo, caijiUrl } = HOST_CONF;

// 开发环境
// const nanfangIfUrl = 'https://testapi.nfnews.com/nanfang_if';//接口
// const nfplusUrl ='https://testapi.nfnews.com/nfplus-manuscript-web' // 热文榜接口
// const staticUrl = 'https://devstatic.nfnews.com';//用于跳转南方号分享页
// const shareUrl = 'https://devstatic.nfnews.com/apptpl/hotArticleShare/';//打榜分享页
// const downloadUrl = 'https://devstatic.nfnews.com/hd/download/download.html';//引导页地址
// const wxLoginUrl = "https://devmember.nfnews.com";//微信授权
// const wxAppId = "wx6354e45fd05077bc";
// const env = 'dev';
// const wxShareLogo = 'https://teststatic.nfnews.com/common/assets/images/nf_logo_artShare.png';

//测试环境
// const nanfangIfUrl = 'https://testapi.nfnews.com/nanfang_if';//接口
// const nfplusUrl ='https://testapi.nfnews.com/nfplus-manuscript-web' // 热文榜接口
// const staticUrl = 'https://teststatic.nfnews.com';//用于跳转南方号分享页
// const shareUrl = 'https://teststatic.nfnews.com/apptpl/hotArticleShare/';//打榜分享页
// const downloadUrl = 'https://teststatic.nfnews.com/hd/download/download.html';//引导页地址
// const wxLoginUrl = "https://testmember.nfnews.com";//微信授权
// const wxAppId = "wx6354e45fd05077bc";
// const env = 'test';
// const wxShareLogo = 'https://teststatic.nfnews.com/common/assets/images/nf_logo_artShare.png';

//预发布环境
// const nanfangIfUrl = 'https://preapi.nfnews.com/nanfang_if';//接口
// const staticUrl = 'https://static.nfnews.com';//用于跳转南方号分享页
// const shareUrl = 'https://static.nfnews.com/apptpl/hotArticleShare/';//打榜分享页
// const downloadUrl = 'https://static.nfnews.com/hd/download/download.html';//引导页地址
// const wxLoginUrl = "https://member.nfnews.com";//微信授权
// const wxAppId = "wx847772b3a82d4e8f";
// const env = '';
// const wxShareLogo = 'https://teststatic.nfnews.com/common/assets/images/nf_logo_artShare.png';

//正式环境
// const nanfangIfUrl = 'https://api.nfnews.com/nanfang_if';//接口
// const nfplusUrl ='https://api.nfnews.com/nfplus-manuscript-web' ;// 热文榜接口
// const staticUrl = 'https://static.nfnews.com';//用于跳转南方号分享页
// const shareUrl = 'https://static.nfnews.com/apptpl/nfhRankList/';//打榜分享页
// const downloadUrl = 'https://static.nfnews.com/hd/download/download.html';//引导页地址
// const wxLoginUrl = "https://member.nfnews.com";//微信授权
// const wxAppId = "wx847772b3a82d4e8f";
// const env = '';
// const wxShareLogo = 'https://static.nfnews.com/common/assets/images/nf_logo_artShare.png';

export { nanfangIfUrl, nfplusUrl, staticUrl, shareUrl, downloadUrl, wxLoginUrl, wxAppId, env, wxShareLogo, caijiUrl };



// WEBPACK FOOTER //
// ./src/js/url.js